import {
  Box,
  Checkbox,
  Chip,
  Collapse,
  FormControlLabel,
  FormGroup,
  List,
  ListSubheader,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import TopicsTable from "./topicsTable";
import EntrolledFilterEmployee from "../IeltsEntrolled/ieltsEntorlledFilterSearch";
import { MdClear } from "react-icons/md";
import { ListItemButton } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { AiOutlineSearch } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { ieltsLearningManagmentFindTopicAction, ieltsLearningTopicFilterAction } from "../../../actions/IeltsActions/learningManadmentAction";
import IeltsFilter from "../IeltsCourseManagement/examTips/ExamFilter"

function TopicsMain({ searchvalue }) {
  const dispatch = useDispatch();
  const [topicList, setTopicList] = useState([]);
  const [secListopen, setSecListOpen] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [categoryList, setCategoyList] = useState([
    "Listening",
    "Reading",
    "Speaking",
    "Writing",
    "Grammar",
    "Exam Tips",
    "Question Bank",
  ]);

  let {
    ieltsLearningManagmentFindTopicSuccess,
    ieltsLearningManagmentFindTopicerror,
  } = useSelector((state) => {
    return state.ieltslearningManagmentFindTopic;
  });
  let {
    ieltsLearningManagmentCreateTopicSuccess,
    ieltsLearningManagmentCreateTopicerror,
  } = useSelector((state) => {
    return state.ieltslearningManagmentCreateTopic;
  });
  let {
    ieltsLearningManagmentEntireTopicDeleteSuccess,
    ieltsLearningManagmentEntireTopicDeleteerror,
  } = useSelector((state) => {
    return state.ieltslearningManagmentEntireTopicDelete;
  });
  let {
    ieltsLearningManagmentTopicStatusChangeSuccess,
    ieltsLearningManagmentTopicStatusChangeerror,
  } = useSelector((state) => {
    return state.ieltslearningManagmentTopicsStatusChange;
  });

  const { ieltsLearningTopicFilterSuccess } = useSelector((state) => state.ieltsLearningTopicFilter)
  
  useEffect(() => {
    dispatch(ieltsLearningManagmentFindTopicAction());
  }, [
    dispatch,
    ieltsLearningManagmentCreateTopicSuccess,
    ieltsLearningManagmentTopicStatusChangeSuccess,
    ieltsLearningManagmentEntireTopicDeleteSuccess,
  ]);

  useEffect(() => {
    if (ieltsLearningManagmentFindTopicSuccess) {
      setTopicList(ieltsLearningManagmentFindTopicSuccess?.data);
    }
  }, [ieltsLearningManagmentFindTopicSuccess]);

  useEffect(() => {
    if(ieltsLearningTopicFilterSuccess) {
      setTopicList(ieltsLearningTopicFilterSuccess?.data)
    }
  }, [ieltsLearningTopicFilterSuccess])

  useEffect(() => {
    if (searchvalue !== "") {
      console.log(searchvalue);
      let filterdata = ieltsLearningManagmentFindTopicSuccess?.data?.filter((item) => {
        return item?.TopicName?.toLowerCase().includes(
          searchvalue?.toLowerCase()
        );
      });
      setTopicList(filterdata);
    } else {
      setTopicList(ieltsLearningManagmentFindTopicSuccess?.data);
    }
  }, [searchvalue]);

  // console.log(topicList, "topicListttttttttttttttttt");
  const columns = [
    { title: "SL NO", field: "sl" },
    { title: "TOPIC NAME", field: "topic name" },
    { title: "CATEGORY", field: "category Name" },
    { title: "STATUS", field: "status" },
  ];

  // handleFilter function

  const handleFilterFunction = (filterValue, checkedStatus) => {
    setSelectedCategory(filterValue === selectedCategory ? null : filterValue);
    if (checkedStatus) {
      setTopicList(
        ieltsLearningManagmentFindTopicSuccess?.data?.filter(
          (topics, index) => {
            return filterValue == topics.Category;
          }
        )
      );
    } else {
      setTopicList(ieltsLearningManagmentFindTopicSuccess.data);
    }
  };

  // Handle ClearAll function

  const handleClearAllFunction = () => {
    setTopicList(ieltsLearningManagmentFindTopicSuccess?.data);
    setSelectedCategory(null);
  };

  const handleClick2 = () => {
    setSecListOpen(!secListopen);
  };

  const [ids, setIds] = useState([]);

  const selectBoxIdPassHandler = (ids) => {
    setIds(ids);
  };

  const handleDelete = () => {
    alert("You deleted the chip");
  };



  const [page, setPage] = useState(10);
  const [pageError, setPageError] = useState("");

  const handlePageSearch = (e) => {
    const { value } = e.target;
    if (value >= 0) {
      setPage(value);
    }
    if (value >= 10) {
      setPageError("");
    } else {
      setPageError("please choose a value greater than 10");
    }
  };

  const leadFilterFunction = (filterData) => {
    try {
      dispatch(ieltsLearningTopicFilterAction(filterData))
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <Box
      sx={{
        mt: 1,
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          lg: "330px 1fr",
        },
        gap: "25px",
      }}
    >
      <Box>
        {selectedCategory ? (
          <Chip
            sx={{
              "&.MuiChip-root": {
                pl: "5px",
                pr: "5px",
              },
              mt: "10px",
            }}
            label={
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: "700",
                  color: "rgba(88, 94, 106, 1)",
                }}
              >
                Category:{" "}
                <Typography
                  sx={{
                    fontSize: "10px",
                    fontWeight: "400",
                  }}
                  component={"span"}
                >
                  {selectedCategory}
                </Typography>
              </Typography>
            }
            onDelete={handleClearAllFunction}
          />
        ) : (
          ""
        )}

        <IeltsFilter
          leadFilterFunction={leadFilterFunction}
          componentName="learningTopics"
        />
      </Box>

      <TopicsTable
        data={topicList}
        columns={columns}
        component="ieltsCategory"
        selectBoxIdPassHandler={selectBoxIdPassHandler}
        pageNumber={page}
        subMenu="learning managment"
      />
    </Box>
  );
}

export default TopicsMain;
